/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Country codes currently supported by the location APIs.
 */
export enum LocationCountryCode {
    CL = 'CL',
    CO = 'CO',
    AR = 'AR',
    BO = 'BO',
    BR = 'BR',
    CR = 'CR',
    CU = 'CU',
    DO = 'DO',
    EC = 'EC',
    ES = 'ES',
    SV = 'SV',
    GT = 'GT',
    HN = 'HN',
    MX = 'MX',
    NI = 'NI',
    PA = 'PA',
    PY = 'PY',
    PE = 'PE',
    PR = 'PR',
    UY = 'UY',
    US = 'US',
    VE = 'VE',
    AW = 'AW',
    CW = 'CW',
    BB = 'BB',
    HT = 'HT',
}
